// extracted by mini-css-extract-plugin
module.exports = {"root":"Details_root__6__Gy","gridContainer":"Details_gridContainer__bUh8G","gridItem":"Details_gridItem__ids4p"};